<template>
    <v-dialog v-model="dialog" width="400">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="mb-2">정보 수정</v-card-title>
            <v-card-text>
                <v-text-field v-model="requestData.codeKey"
                              label="담당자"
                              dense
                ></v-text-field>
                <v-text-field v-model="requestData.codeValue"
                              label="support@tinteccnc.com"
                              dense
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error darken-1" text @click="dialog = false">취소</v-btn>
                <v-btn color="green darken-1" text @click="onClickSave">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";

    export default {
        name: "ChargeEmailSignupEditModal",
        props: {
            item: undefined,
        },
        data() {
            return {
                dialog: false,
                requestData: {
                    codeKey: this.item.codeKey,
                    codeValue: this.item.codeValue,
                },
            }
        },
        watch: {
            item() {
                this.requestData.codeKey = this.item.codeKey;
                this.requestData.codeValue = this.item.codeValue;
            },
        },
        methods: {
            onClickSave() {
                const codeKey = (this.requestData.codeKey || "").trim();
                const codeValue = (this.requestData.codeValue || "").trim();
                if (!codeKey || !codeValue) {
                    this.$alert("담당자 이름과 담당자 이메일을 입력하세요.<br>앞 뒤의 공백문자는 무시합니다.");
                    return;
                }
                this.requestUpdate(codeKey, codeValue);
            },

            async requestUpdate(codeKey, codeValue) {
                await this.$requestWithOverlay(PATH.CODE.UPDATE)
                    .setObject({
                        ...this.item,
                        codeKey: codeKey,
                        codeValue: codeValue,
                    })
                    .enqueue();
                this.$emit("update");
            },
        },
    }
</script>

<style scoped>

</style>
